export const BASE_URL = "https://voicebioapi.fintra.ai/core/api/v1";
// export const BASE_URL = "http://18.143.16.145:8888/api/v1";
// Old URL
// "http://18.143.16.145:8888/api/v1";
